import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import App from './App'
import Play2Visit from './pages/Play2Visit'
import Play2VisitV2 from './pages/Play2VisitV2'
import Partners from './pages/Partners'
import TrainingModule from './pages/TrainingModule'
import Quiz from './pages/Quiz'
import PartnerSlideshow from './pages/PartnerSlideshow'
import PartnerSlideshowApp from './pages/PartnerSlideshow-app'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Play2VisitV2 />} />
        <Route path="/en" element={<Navigate to="/" replace />} />
        <Route path="/fi" element={<Navigate to="/" replace />} />
        <Route path="/:lng/play2visit" element={<Navigate to="/" replace />} />
        <Route path="/:lng/play2visit-v2" element={<Play2VisitV2 />} />
        <Route path="/:lng/partners" element={<Partners />} />
        <Route path="/:lng/training" element={<TrainingModule />} />
        <Route path="/:lng/quiz" element={<Quiz />} />
        <Route path="/:lng/partners/slideshow" element={<PartnerSlideshow />} />
        <Route path="/:lng/partners_app/slideshow" element={<PartnerSlideshowApp />} />
        {/* note the `/*` here so that any subpath (or hash) stays in App */}
        <Route path="/:lng/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)

reportWebVitals()
